export default "__VITE_ASSET__5c009a54__"